import { tw } from '../../utils';

export const themeClasses = {
  primary: 'bg-white text-black',
  secondary: 'bg-[#242424] text-white',
  mint: 'bg-[#95f2c5] font-bold text-black',
  gold: 'bg-one-of-one font-bold text-black',
};

export interface PillProps {
  label: string;
  theme: 'primary' | 'secondary' | 'mint' | 'gold';
  onClick: () => void;
  isActive?: boolean;
  className?: string;
}

export const Pill: React.FC<PillProps> = ({
  label,
  theme = 'primary',
  onClick,
  isActive,
  className,
  ...props
}: PillProps) => {
  return (
    <div className='relative'>
      <button
        className={tw(
          'font-fredoka rounded-full px-4 py-1 text-xs',
          themeClasses[theme],
          isActive ? 'font-bold' : 'font-normal',
          className || '',
          !isActive && theme === 'gold' ? 'bg-one-of-one p-0.5' : 'px-4 py-1',
        )}
        {...props}
      >
        <div
          className={tw(
            !isActive && theme === 'gold'
              ? 'rounded-full bg-[#242424] px-3.5 py-0.5 text-white'
              : null,
          )}
        >
          {label}
        </div>
      </button>
      <div
        className='absolute inset-0 z-20 cursor-pointer'
        onClick={onClick}
      />
    </div>
  );
};
